import React from "react";
import FilterStatusChip, { FilterStatus } from "./filter-status-chip";

export const FILTER_STATUSES: FilterStatus[] = [
  "ALL", // 전체 주문
  "PENDING", // 확인 필요 주문
  "CONFIRMED", // 확정 주문
];

interface FilterBarProps {
  selectedStatus: FilterStatus;
  onStatusChange: (status: FilterStatus) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  selectedStatus,
  onStatusChange,
}) => {
  return (
    <div className="flex overflow-x-scroll gap-2 p-4 px-2 scrollbar-hide w-full">
      {FILTER_STATUSES.map((status) => {
        const isSelected = selectedStatus === status;

        return (
          <FilterStatusChip
            key={status}
            status={status}
            isSelected={isSelected}
            onClick={() => onStatusChange(status)}
          />
        );
      })}
    </div>
  );
};

export default FilterBar;
